import {Controller} from 'stimulus';
/*
import Masonry from 'masonry-layout';

const grid = document.querySelector('.masonry-grid');
if (grid) {
  const msnry = new Masonry(grid, {
    itemSelector: '.work-item',
    percentPosition: true,
    columnWidth: '.work-item',
    gutter: 5,
    transitionDuration: 100,
    initLayout: false
  })
}
 */
export default class extends Controller {

  static targets = [];

  connect() {
    // let ac = this.pfilterTarget;
    /*
    if (grid) {
      msnry.once('layoutComplete', () => {
        grid.classList.add('load')
      })

      document.onreadystatechange = function (event) {
        if (document.readyState === "complete") {
          msnry.layout()
        }
      };
    }
     */
  }

  filter(e) {
    e.preventDefault();
    let filter = e.target;
    var filteredClass = filter.getAttribute('data-filter');
    if(filteredClass == '*') {
      var appBanners = document.getElementsByClassName('work-item');
      for (var i = 0; i < appBanners.length; i ++) {
        appBanners[i].classList.add('show');
      }
      var filters = document.getElementsByClassName('filter');
      for (var i = 0; i < filters.length; i ++) {
        filters[i].classList.remove('active');
      }
      filters[0].classList.add('active');
    }
    else {
      var appBanners = document.getElementsByClassName('work-item');
      for (var i = 0; i < appBanners.length; i ++) {
        appBanners[i].classList.remove('show');
      }
      var filters = document.getElementsByClassName('filter');
      for (var i = 0; i < filters.length; i ++) {
        filters[i].classList.remove('active');
      }
      filter.classList.add('active');
      for (var i = 0; i < appBanners.length; i ++) {
        if(appBanners[i].classList.contains(filteredClass)) {
          appBanners[i].classList.add('show');

        }
      }
    }

  }
}


/*
$('.portfolio-filter').on( 'click', 'a', function(e) {
        e.preventDefault();
        var filterValue = $(this).attr('data-filter');
        $container.isotope({ filter: filterValue });

        $('.portfolio-filter a').removeClass('active');
        $(this).closest('a').addClass('active');

    });
 */
